import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: './pages/pages.module#PagesModule',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/app.routing.ts